/**
 * Tames the Shopify Forms popup (the 10%-off email capture).
 *
 * Out of the box the embed shows immediately and closing the modal only
 * minimizes it to a corner teaser; closing the teaser re-opens the modal, so
 * a shopper can never actually get rid of it. This wrapper:
 *
 *  1. keeps the whole embed hidden for the first DELAY_MS of a page view, so
 *     the modal appears once the shopper has had time to look around;
 *  2. treats ANY close click inside the embed (modal X or teaser X) as a real
 *     dismissal: the embed is hidden on the spot and stays hidden for
 *     DISMISS_DAYS across the whole site.
 *
 * Submitting the form is untouched — only close buttons trigger a dismissal.
 * The Forms embed lives in an open shadow root, so clicks surface through
 * composedPath(); we match its close controls by aria-label/class.
 */
(function () {
  'use strict';

  var DISMISS_KEY = 'brand:forms-popup-dismissed-at';
  var DELAY_MS = 11000;
  var DISMISS_DAYS = 7;
  var HOST_TAG = 'shopify-forms-embed';

  var style = document.createElement('style');
  style.textContent = HOST_TAG + ' { display: none !important; }';

  function dismissedRecently() {
    try {
      var at = Number(localStorage.getItem(DISMISS_KEY) || 0);
      return at && Date.now() - at < DISMISS_DAYS * 24 * 60 * 60 * 1000;
    } catch (error) {
      return false;
    }
  }

  function hide() {
    if (!style.isConnected) document.head.appendChild(style);
  }

  function reveal() {
    if (style.isConnected) style.remove();
  }

  function dismiss() {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch (error) {
      /* private mode: hide for this page view only */
    }
    hide();
  }

  hide();
  if (dismissedRecently()) return;

  var start = function () {
    setTimeout(reveal, DELAY_MS);
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });

  function isCloseControl(node) {
    if (!node || node.nodeType !== 1 || !node.getAttribute) return false;
    var aria = node.getAttribute('aria-label') || '';
    var cls = typeof node.className === 'string' ? node.className : '';
    return /close/i.test(aria) || /close/i.test(cls);
  }

  document.addEventListener(
    'click',
    function (event) {
      var path = event.composedPath ? event.composedPath() : [];
      var inEmbed = false;
      var isClose = false;
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (isCloseControl(node)) isClose = true;
        if (node.tagName && node.tagName.toLowerCase() === HOST_TAG) inEmbed = true;
      }
      if (inEmbed && isClose) dismiss();
    },
    true
  );
})();
